/**
 * ChartMind Gemini Live bilingual interpreter path.
 * On by default so teams can trial; set REACT_APP_CHARTMIND_LIVE_INTERPRETER_DISABLED=true to turn off.
 * (Legacy opt-in REACT_APP_CHARTMIND_LIVE_INTERPRETER_ENABLED is ignored — use DISABLED only.)
 *
 * {@link isChartMindGeminiLiveUngatedForTrials} ignores DISABLED during local dev / DEV_UNGATED.
 */

import { isChartMindGeminiLiveUngatedForTrials } from './chartmindGeminiLiveDevTrialMode';

export const isChartMindLiveInterpreterFeatureEnabled = () => {
  if (isChartMindGeminiLiveUngatedForTrials()) return true;
  if (typeof process !== 'undefined' && process.env.REACT_APP_CHARTMIND_LIVE_INTERPRETER_DISABLED === 'true') {
    return false;
  }
  return true;
};
